import { Component, OnInit,ViewChild } from '@angular/core';
import { Variable } from '@angular/compiler/src/render3/r3_ast';
import { CustomField } from '../models/customfield';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { FieldCustomizationService } from '../services/field-customization/field-customization.service';
import { Account } from '../models/account';
import { AccountService } from '../services/account/account.service';
//import { $ } from 'protractor';
import { CustomSection } from '../models/CustomSection';
import { CustomFieldConfig } from '../models/customfieldconfig';
import {ActiveCustomFieldConfig} from '../models/activeCustomFieldConfig';
import { FormGroup,FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BelongsToField } from '../models/BelongsToField';
import { ConfigurableFieldOption } from '../models/ConfigurableFieldOption';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';
import { ServiceProvider } from '../models/service-provider';

declare var $: any;

@Component({
  selector: 'app-form-customization',
  templateUrl: './field-customization.component.html',
  styleUrls: ['./field-customization.component.css']
})

export class FieldCustomizationComponent implements OnInit {

  @ViewChild('configureFieldOptionsPopUp', { static: true }) configureFieldOptionsPopUp: ModalDirective;

  regf:FormGroup;
  fieldTypes=["Text Box","Number","Radio Button","Check Box","Drop Down","Text Area","Multiselect","Date","Country Mobile Code"];
  refractionFieldTypes=["Text Box","Number","Radio Button","Check Box","Drop Down","Text Area","Multiselect","Date","Country Mobile Code","Uncorrected DVA","Pinhole DVA","Corrected DVA","Objective Readings","Subjective Readings"];
  FieldCustomizationList: CustomField[]=[];
  sectionCustomizationList:CustomSection[]=[];
  customFieldConfig : CustomFieldConfig;
  activeCustomFieldConfig:ActiveCustomFieldConfig;
  disableButtonFlag:boolean;
  isEligibleToSubmit:boolean=false;
  foruscareService: ForuscareService;
  accounts:Account[];
  modules:{};//string[];
  accountId=null;
  tab;
  moduleId='Patient';
  activeCustomFields:CustomField[]=[];
  showDefaultFields;
  deviceTypes=[{"name":"Enter device type","value":null},{"name":"Classic","value":"CLASSIC"},{"name":"Classic HD","value":"CLASSIC_HD"},{"name":"Neo","value":"NEO"},{"name":"Neo HD","value":"NEO_HD"},{"name":"Ultima","value":"ULTIMA"},{"name":"Aberro","value":"Aberro"}];
  fieldIdentities=[{"name":"Name","value":"NAME"},{"name":"Age","value":"AGE"},
  {"name":"Gender","value":"GENDER"},{"name":"Dob","value":"DOB"},{"name":"Email","value":"EMAIL"},{"name":"Mobile","value":"MOBILE"},
  {"name":"Country Code","value":"COUNTRY_CODE"},{"name": "Address","value": "ADDRESS"},
  {"name": "Pin Code","value": "PINCODE"},{"name": "State Name","value": "STATE_NAME"},
  {"name": "District Name","value": "DISTRICT_NAME"},{"name": "Abha Number","value": "ABHA_NUMBER"},
  {"name": "Abha Address","value": "ABHA_ADDRESS"} ];
  refractionFieldIdentities=[{"name":"Select field identity","value":"NONE"},{"name":"Right Eye Corrected DVA",
  "value":"RIGHT_EYE_CORRECTED_DVA"},{"name":"Left Eye Corrected DVA","value":"LEFT_EYE_CORRECTED_DVA"},
  {"name":"Both Eye Corrected DVA","value":"BOTH_EYE_CORRECTED_DVA"},
  {"name":"Right Eye Un-Corrected DVA","value":"RIGHT_EYE_UNCORRECTED_DVA"},
  {"name":"Left Eye Un-Corrected DVA","value":"LEFT_EYE_UNCORRECTED_DVA"},
  {"name":"Both Eye Un-Corrected DVA","value":"BOTH_EYE_UNCORRECTED_DVA"},
  {"name":"Right Eye Pinhole DVA","value":"RIGHT_EYE_PINHOLE_DVA"},
  {"name":"Left Eye Pinhole DVA","value":"LEFT_EYE_PINHOLE_DVA"},{"name":"Both Eye Pinhole DVA","value":"BOTH_EYE_PINHOLE_DVA"},
  {"name":"Right Eye Near Vision","value":"RIGHT_EYE_NV"},{"name":"Left Eye Near Vision","value":"LEFT_EYE_NV"},
  {"name":"Right Eye Un-Corrected Near Vision","value":"RIGHT_EYE_UNCORRECTED_NV"},{"name":"Left Eye Un-Corrected Near Vision","value":"LEFT_EYE_UNCORRECTED_NV"},
  {"name":"Remarks","value":"REMARKS"}];
  teleOptometryFieldIdentities=[{"name":"Select field identity","value":"NONE"},{"name":"Right Eye Corrected DVA","value":"RIGHT_EYE_CORRECTED_DVA"},{"name":"Left Eye Corrected DVA","value":"LEFT_EYE_CORRECTED_DVA"},{"name":"Both Eye Corrected DVA","value":"BOTH_EYE_CORRECTED_DVA"},{"name":"Right Eye Un-Corrected DVA","value":"RIGHT_EYE_UNCORRECTED_DVA"},{"name":"Left Eye Un-Corrected DVA","value":"LEFT_EYE_UNCORRECTED_DVA"},{"name":"Both Eye Un-Corrected DVA","value":"BOTH_EYE_UNCORRECTED_DVA"},{"name":"Right Eye Pinhole DVA","value":"RIGHT_EYE_PINHOLE_DVA"},{"name":"Left Eye Pinhole DVA","value":"LEFT_EYE_PINHOLE_DVA"},{"name":"Both Eye Pinhole DVA","value":"BOTH_EYE_PINHOLE_DVA"},{"name":"Right Eye Near Vision","value":"RIGHT_EYE_NV"},{"name":"Left Eye Near Vision","value":"LEFT_EYE_NV"}];
  spectacleOrderFieldIdentities=[{"name":"Select field identity","value":"NONE"},{"name":"Spectacle Ordered","value":"SPECTACLE_ORDERED"},{"name":"Spectacle Received","value":"SPECTACLE_RECEIVED"},{"name":"Spectacle Ordered Date","value":"SPECTACLE_ORDERED_DATE"},{"name":"Spectacle Received Date","value":"SPECTACLE_RECEIVED_DATE"} ];

  belongsToFieldList:BelongsToField[]=[];
  belongsToFieldObject:BelongsToField;
  configurableFieldOptionObject:ConfigurableFieldOption;
  configurableFieldOptionList:ConfigurableFieldOption[]=[];
  selectedObjectIndex:any;
  public serviceProviders: ServiceProvider[];
  serviceProviderId=null;
  roleType=false;
  duplicatesPresent:any[]=[];
 constructor(public fieldCustomizationService:FieldCustomizationService,public accountService:AccountService,private activatedRoute:ActivatedRoute,private serviceProviderService:ServiceProviderService) { 
    //this.FieldCustomizationList.push(new CustomField());
    this.disableButtonFlag=false;
    this.foruscareService=new ForuscareService();
    this.customFieldConfig=new CustomFieldConfig();
    this.customFieldConfig.customFields=[];
    this.customFieldConfig.sections=[];
    this.activeCustomFieldConfig=new ActiveCustomFieldConfig();
    this.activeCustomFieldConfig.customFields=[];
    this.activeCustomFieldConfig.sections=[];
    this.belongsToFieldObject=new BelongsToField();
    this.configurableFieldOptionObject=new ConfigurableFieldOption();
    //this.modules=["Patient","Medical Info","Referral","Address"];
    this.modules=[{"id":"Patient","label":"Patient"},{"id":"Medical Info","label":"Medical Info"},{"id":"Referral","label":"Referral"},{"id":"ADDRESS","label":"Address"},{"id":"REFRACTION","label":"Refraction"},{"id":"EXPERT_FUNDUS","label":"Expert"},{"id":"DOAAS","label":"Tele Optometry"}];  
  }

  ngOnInit() {
    this.getAvailableAccounts();
    this.getExistingServiceProviders();
    this.showDefaultFields=true;
    
    // to get the path param value
    this.activatedRoute.paramMap.subscribe(params => { 
      this.accountId = Number(params.get('accountId'));
    });

    /*sorting field identies by value*/
    this.fieldIdentities.sort((t1:any,t2:any)=>{
      if(t1.name<t2.name) return -1;
      if(t1.name>t2.name) return 1;
      return 0
    });
    this.fieldIdentities.unshift({"name":"Select field identity","value":"NONE"});
  }
  
  initializeDefaultTemplate(moduleId){
    if(moduleId=='Referral'){
    }
  }
  getCustomFieldsByAccountId()
  {
    if((this.accountId!=null && this.accountId >0) || (this.serviceProviderId!=null && this.serviceProviderId >0))
    {
    this.fieldCustomizationService.getAllFieldsByAccountIdAndModule(this.accountId,this.moduleId,null,this.serviceProviderId).subscribe(response=>{
      if(response.errorCode==200 && response.status == this.foruscareService.RESULT_SUCCESS)
      {
        if (response.data != null) {
          
          this.customFieldConfig=response.data;
          
        }
        else{
          //this.FieldCustomizationList=[];
          //this.FieldCustomizationList.push(new CustomField(this.accountId,true,this.moduleId));
          
        }
        this.disableButton();
      }
      else {
        //this.foruscareService.showNotification(response.message, "danger");
      }
    });
  }
    
  }
  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  getExistingServiceProviders() {
    this.serviceProviders = [];
    this.serviceProviderService.getExistingProviders()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                name: 'Select Service Provider',
                id: 0
              });
            }
            response.data.forEach(element => {
              element.id=Number(element.id);
            });
            this.serviceProviders = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  callback_validateCustomFields(list1):boolean
  {
    if(list1.length!=0){
    if( list1.fieldName!=null && list1.fieldName.length>0 && list1.fieldType!=null){
      if(list1.fieldType=='Drop Down' || list1.fieldType=='Check Box' || list1.fieldType=='Radio Button' || list1.fieldType=='Multiselect'){
        if(list1.fieldOptions!=null && list1.fieldOptions.length>0){
          return true;
        }
        else return false;
      }
      else return true;
    }
    else return false;
  }
    else{
      return false;
    }
  }
  
  callback_validateSections(list2):boolean
  {
    if((list2.sectionName!=null && list2.sectionName.length>0)){
    for(var i=0;i<list2.customFields.length;i++){
      if(list2.customFields[i].fieldName==null || list2.customFields[i].fieldName.length==0 || list2.customFields[i].fieldType==null ||((list2.customFields[i].fieldType=='Drop Down' || list2.customFields[i].fieldType=='Check Box' || list2.customFields[i].fieldType=='Radio Button' || list2.customFields[i].fieldType=='Multiselect')&& (list2.customFields[i].fieldOptions==null ||list2.customFields[i].fieldOptions.length==0))){
      return false;}
    }
    return true;
  }
  else{
  return false;
  }
    /*if(list2.length!=0){
      if(list2.sectionName!=null && list2.sectionName.length>0 ){

        if(list2.customFields.length!=0)
          if(list2.customFields.every(this.callback_validateCustomFields)){
            return true;
          }
          else return false;
        else return false;}


    else{
    return false;}}
    else{
      return false;}*/
  }
  addNewRow(element,index)
  {
    var validFormFlag=true;
    if(element=='sectionField')
    {
      if(index!=null && this.customFieldConfig.sections[index].customFields.every(this.callback_validateCustomFields)){
      validFormFlag=true;}
      else{
      validFormFlag=false;
      this.foruscareService.showNotification("Please enter all the mandatory fields.", "warning");}
    }
    else{
      if(this.customFieldConfig.customFields.every(this.callback_validateCustomFields) && this.customFieldConfig.sections.every(this.callback_validateSections) ){
        validFormFlag=true;
      }
      else{
      validFormFlag=false;
      this.foruscareService.showNotification("Please enter all the mandatory fields.", "warning");
      }
    }
    
    if(validFormFlag==true){
      if(element=='field'){
      //this.FieldCustomizationList.push(new CustomField());}
      this.customFieldConfig.customFields.push(new CustomField(this.accountId,true,this.moduleId,this.serviceProviderId));
      }
      if(element=='section'){
        //this.sectionCustomizationList.push(new CustomSection());
        this.customFieldConfig.sections.push(new CustomSection(this.accountId,true,this.moduleId));
      }
      if(element=='sectionField'){
        //this.sectionCustomizationList[index].customFields.push(new CustomField());
        this.customFieldConfig.sections[index].customFields.push(new CustomField(this.accountId,true,this.moduleId,this.serviceProviderId));
        
      }
    }
    this.disableButton();
  }

  removeRow(index,operation,rowtype,sectionIndex)
  {
    if(operation=='delete'){
      if(rowtype=='field'){
      if(this.customFieldConfig.customFields[index].id==null){
        this.customFieldConfig.customFields.splice(index,1);
      }
      else if (this.customFieldConfig.customFields[index].id!=null){
        this.customFieldConfig.customFields[index].status=false;
      }
      }
      if(rowtype=='section'){
        if(this.customFieldConfig.sections[sectionIndex].id==null){
          this.customFieldConfig.sections.splice(sectionIndex,1);
        }
        else if (this.customFieldConfig.sections[sectionIndex].id!=null){
          this.customFieldConfig.sections[sectionIndex].status=false;
        }
        }
      if(rowtype=='field_section'){
          if(this.customFieldConfig.sections[sectionIndex].customFields[index].id==null){
            this.customFieldConfig.sections[sectionIndex].customFields.splice(index,1);
          }
          else if (this.customFieldConfig.sections[sectionIndex].customFields[index].id!=null){
            this.customFieldConfig.sections[sectionIndex].customFields[index].status=false;
          }
          }
    }
    else if(operation=='undo'){
      if(rowtype=='field'){
      this.customFieldConfig.customFields[index].status=true;
      }
      if(rowtype=='section'){
          this.customFieldConfig.sections[sectionIndex].status=true;
        }
        if(rowtype=='field_section'){
          this.customFieldConfig.sections[sectionIndex].customFields[index].status=true;
        }
      }
    this.disableButton();
  }

 disableButton()
 {
   var flag=false;
   if(this.customFieldConfig.customFields.every(this.callback_validateCustomFields) && this.customFieldConfig.sections.every(this.callback_validateSections) ){
      flag=true;
      this.disableButtonFlag=false;
   }
   else{
    this.disableButtonFlag=true;
   }
   
}

checkUniqueField(fieldName,sectionIndex){
  if(sectionIndex==null){
  for(var i=0;i<this.customFieldConfig.customFields.length-1;i++){
    if(this.customFieldConfig.customFields[i].fieldName==fieldName){
    this.foruscareService.showNotification("Enter Unique Value", "warning");
    }
  }}
  if(sectionIndex!=null){
    for(var i=0;i<this.customFieldConfig.sections[sectionIndex].customFields.length-1;i++){
      if(this.customFieldConfig.sections[sectionIndex].customFields[i].fieldName==fieldName){
      this.foruscareService.showNotification("Enter Unique Value", "warning");
      }
    }
  }

}
validateLength(minCount,maxCount) 
{
  if(minCount!=null && maxCount!=null && minCount>maxCount){
    this.foruscareService.showNotification("Min length can NOT be greater than Max length", "warning");
    this.disableButtonFlag=true;
    
  }
  else{
    this.disableButtonFlag=false;
  }
  //this.disableButton();
}

  onSubmit()
  {
   
    this.customFieldConfig.accountId=this.accountId;
    this.customFieldConfig.customFields.forEach((data,order)=>{
      data.fieldOrder=order+1;
    });
    this.customFieldConfig.sections.forEach((data,sectionOrder)=>{
      data.sectionOrder=sectionOrder+1;
      this.customFieldConfig.sections[sectionOrder].customFields.forEach((data,fieldOrder_section)=>{
        data.fieldOrder=fieldOrder_section+1;
      });
    });
    
    this.fieldCustomizationService.addOrUpdateCustomFields(this.accountId,this.customFieldConfig).subscribe(response=>{
      if(response.errorCode==200 && response.status==this.foruscareService.RESULT_SUCCESS){
        this.foruscareService.showNotification("Field Updated Successfully !", "success");
        this.getCustomFieldsByAccountId();
      }
      else{
        this.foruscareService.showNotification(response.message, "danger");
      }
    });
  }
  resetPage()
  {
    for(var i=0;i<this.customFieldConfig.customFields.length;i++){
      if(this.customFieldConfig.customFields[i].id==null)
      {
        this.customFieldConfig.customFields.splice(i,1);
        i--;
      }
    }
    for(var i=0;i<this.customFieldConfig.sections.length;i++){
      if(this.customFieldConfig.sections[i].id==null)
      {
        this.customFieldConfig.sections.splice(i,1);
        i--;
      }
      else{
        for(var j=0;j<this.customFieldConfig.sections[i].customFields.length;j++){
              if(this.customFieldConfig.sections[i].customFields[j].id==null)
                {
                  this.customFieldConfig.sections[i].customFields.splice(j,1);
                  j--;
                }
        }
      }
    }
    
    
  }
  getAllActiveFields(){
    this.activeCustomFieldConfig.customFields=[];
    this.activeCustomFieldConfig.sections=[];
    for(var tempI=0;tempI<this.customFieldConfig.customFields.length;tempI++){
      if(this.customFieldConfig.customFields[tempI].status==true){
        this.activeCustomFieldConfig.customFields.push(this.customFieldConfig.customFields[tempI]);
      }
    }
    for(var tempI=0;tempI<this.activeCustomFieldConfig.customFields.length;tempI++){
      this.activeCustomFieldConfig.customFields[tempI].multiSelectOptions=[];
      if(this.activeCustomFieldConfig.customFields[tempI].fieldType=='Multiselect' && this.activeCustomFieldConfig.customFields[tempI].fieldOptions!=null && this.activeCustomFieldConfig.customFields[tempI].fieldOptions.length>0){
        var tempArray=this.activeCustomFieldConfig.customFields[tempI].fieldOptions.split(',');
        for(var tempJ=0;tempJ<tempArray.length;tempJ++){
          this.activeCustomFieldConfig.customFields[tempI].multiSelectOptions.push({"id":tempJ,"itemName":tempArray[tempJ]})
        }
      }
    }
    for(var tempI=0;tempI<this.customFieldConfig.sections.length;tempI++){
      if(this.customFieldConfig.sections[tempI].status==true){
        this.activeCustomFieldConfig.sections.push(this.customFieldConfig.sections[tempI]);
      }
    }
    for(var tempI=0;tempI<this.activeCustomFieldConfig.sections.length;tempI++){
      for(var tempK=0;tempK<this.activeCustomFieldConfig.sections[tempI].customFields.length;tempK++){
        this.activeCustomFieldConfig.sections[tempI].customFields[tempK].multiSelectOptions=[];
      if(this.activeCustomFieldConfig.sections[tempI].customFields[tempK].fieldType=='Multiselect' && this.activeCustomFieldConfig.sections[tempI].customFields[tempK].fieldOptions!=null && this.activeCustomFieldConfig.sections[tempI].customFields[tempK].fieldOptions.length>0){
        var tempArray=this.activeCustomFieldConfig.sections[tempI].customFields[tempK].fieldOptions.split(',');
        for(var tempJ=0;tempJ<tempArray.length;tempJ++){
          this.activeCustomFieldConfig.sections[tempI].customFields[tempK].multiSelectOptions.push({"id":tempJ,"itemName":tempArray[tempJ]})
        }
      }
    }
    }
    
  }
      addNewFieldInConfigureFieldOptions(){
        this.configurableFieldOptionList.push(new ConfigurableFieldOption());
      }
      removeConfigurableFieldOption(configurableFieldIndex){
        this.configurableFieldOptionList.splice(configurableFieldIndex,1);
      }
      showConfigureFieldOptionsPopUp(){
        this.configureFieldOptionsPopUp.show();
      }
      hideConfigureFieldOptionsPopUp(){
        this.disableButton();
        this.configureFieldOptionsPopUp.hide();
        this.belongsToFieldList.splice(0);
        this.configurableFieldOptionList.splice(0);

      }
      
      setConfigurableFieldOption(){
        var flag=true;
        this.configurableFieldOptionList.forEach(element => {
          if(element.id==null || element.id.trim()=='' || element.value==null || element.value.trim()==''){
            this.foruscareService.showNotification("Enter code and name for all the rows.","danger");
            flag=false;
            return;
          }
        });
        if(flag==true){
        this.customFieldConfig.customFields[this.selectedObjectIndex].fieldOptions=JSON.stringify(this.configurableFieldOptionList);
        this.disableButton();
        this.hideConfigureFieldOptionsPopUp();
        }
      }
      configureFieldOptions(fieldElement,index){
          this.selectedObjectIndex=index;
          //this.belongsToFieldList.push(this.belongsToFieldObject);
          /*if(fieldElement.parentFieldId==null || fieldElement.parentFieldId=="" || fieldElement.parentFieldId=='null'){
            this.belongsToFieldObject.code=null;
            this.belongsToFieldObject.name="Select the field belongs to";
            this.belongsToFieldList.push(this.belongsToFieldObject);
          }*/
          if(fieldElement.parentFieldId!=null && fieldElement.parentFieldId!="" && fieldElement.parentFieldId!='null'){
            if(isNaN(Number(fieldElement.parentFieldId))==false){
            this.customFieldConfig.customFields.forEach(element => {
              if(element.id==fieldElement.parentFieldId){
                var temp=JSON.parse(element.fieldOptions);
                temp.forEach(element2 => {
                  this.belongsToFieldObject=new BelongsToField();
                  this.belongsToFieldObject.code=element2.id;
                  this.belongsToFieldObject.name=element2.value;
                  this.belongsToFieldList.push(this.belongsToFieldObject);
                });
              }
            });
          }
            if(isNaN(Number(fieldElement.parentFieldId))==true){
              this.customFieldConfig.customFields.forEach(element => {
                if(element.fieldName==fieldElement.parentFieldId){
                  var temp=JSON.parse(element.fieldOptions);
                  temp.forEach(element2 => {
                    this.belongsToFieldObject=new BelongsToField();
                    this.belongsToFieldObject.code=element2.id;
                    this.belongsToFieldObject.name=element2.value;
                    this.belongsToFieldList.push(this.belongsToFieldObject);
                  });
                }
              });
            }
          }
          this.belongsToFieldList=this.belongsToFieldList.sort((a,b)=>(a.name > b.name) ? 1  : -1 ); // to sort based of belongd to field
          this.belongsToFieldList.unshift({
          code:null,
          name:"Select the field belongs to"
          });

          if(fieldElement.fieldOptions!=null && fieldElement.fieldOptions.length>0){
            var temp = JSON.parse(fieldElement.fieldOptions);
            temp.forEach(element => {
              this.configurableFieldOptionObject=new ConfigurableFieldOption();
              this.configurableFieldOptionObject.id=element.id;
              this.configurableFieldOptionObject.value=element.value;
              this.configurableFieldOptionObject.parentCode=element.parentCode;
              this.configurableFieldOptionList.push(this.configurableFieldOptionObject);
            });
          }
          else{
            this.configurableFieldOptionList.push(new ConfigurableFieldOption());
          }
          this.configureFieldOptionsPopUp.show();
      }
      onSelectRoleType(roleType){
          if(roleType==true){
          this.modules=[{"id":"ADDRESS","label":"Address"}];
          this.moduleId='ADDRESS';
          }
          else{
            this.modules=[{"id":"Patient","label":"Patient"},{"id":"Medical Info","label":"Medical Info"},{"id":"Referral","label":"Referral"},{"id":"ADDRESS","label":"Address"}];
            this.moduleId='Patient';
          }
          this.serviceProviderId=null;
          this.accountId=null;
      }
      validateCode(inputCode){
        var tempList=this.configurableFieldOptionList.filter(function(itrObj,index){
          return itrObj.id==inputCode;
        });
        if(tempList.length>1){
          this.isEligibleToSubmit=true;
          this.foruscareService.showNotification("Duplicate codes not allowed","danger");
        }
        else{
          this.isEligibleToSubmit=false;
        }
      }
      isDuplicatePresent(customfield){
        this.duplicatesPresent = [];
        if(customfield.id!=null && customfield.id>0 && customfield.isUnique){
          this.fieldCustomizationService.isDuplicatePresent(customfield.id)
          .subscribe(response=>{
            if(response.errorCode==200 && response.data!=null){
              this.duplicatesPresent = response.data;
              $('#duplicateValuePopUp').modal("show");
            }
          },error=>{
            this.foruscareService.showNotification("Something went wrong","danger");
          });
        }
      }
}


